<script>

import CommonSubtitle from "../../CommonSubtitle/index.vue";
import CustomTextField from "../../CustomInput/CustomTextField.vue";
import CustomTextDropdown from "../../CustomInput/CustomDropdown.vue";
import CustomCheckbox from "../../global/CustomCheckBox/CheckBox.vue";
import CustomCheckboxGroup from "../../global/CustomCheckBox/CheckBoxGroup.vue";
import {FinancialCodes} from "../../../constants";
import {Occupations} from "../../../utils/constants";
import {mapState} from "vuex";

export default {
  name: "FinancialInfo",
  components: {CustomCheckboxGroup, CustomCheckbox, CustomTextDropdown, CustomTextField, CommonSubtitle},
  props: {
    financialInfo: {
      type: Object,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isChecked: false,
      selectedSourceOptions: [],
      selectedIncomeOptions: [],
      selectedTradeOptions: [],
      sourceOptions: [
        {value: '1', name: this.$t('kyc.source_options.1')},
        {value: '2', name: this.$t('kyc.source_options.2')},
        {value: '3', name: this.$t('kyc.source_options.3')},
        {value: '4', name: this.$t('kyc.source_options.4')},
        {value: '5', name: this.$t('kyc.source_options.5')},
        {value: '6', name: this.$t('kyc.source_options.6')},
        {value: '0', name: this.$t('kyc.source_options.0')},
      ],
      incomeOptions: FinancialCodes.salary.map(item => ({value: item.value, name: item.name})),
      tradeOptions: FinancialCodes.salary.map(item => ({value: item.value, name: item.name}))
    }
  },
  computed: {
    ...mapState('user', ['user']),
  },
  mounted() {
    if (this.user) {
      if (this.user.source_of_income) {
        this.selectedSourceOptions = this.user.source_of_income.split(';')
      }
      if(this.user.source_of_income_text){
        this.financialInfo.source_of_income_text = this.user.source_of_income_text
      }
      if (this.user.salary)
        this.selectedIncomeOptions.push(this.user.salary)
      if (this.user.trading_amount)
        this.selectedTradeOptions.push(this.user.trading_amount)
    }
  },
  watch: {
    selectedSourceOptions() {
      this.financialInfo.source_of_income = this.selectedSourceOptions.join(';');
    },
    selectedIncomeOptions() {
      this.financialInfo.salary = this.selectedIncomeOptions.join('');
    },
    selectedTradeOptions() {
      this.financialInfo.trading_amount = this.selectedTradeOptions.join('');
    }
  }
}
</script>

<template>
  <div>
    <CommonSubtitle :name="$t('kyc.financial_info')"/>
    <div class="ml-4">
      <h5 class="kyc-sub-title">{{ $t('kyc.source_of_income') }}</h5>
      <CustomCheckboxGroup v-model="selectedSourceOptions"
                           :options="sourceOptions"
                           :multiple="true"
      >
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 ml-auto" v-if="selectedSourceOptions.includes('0')">
          <CustomTextField
              :label="$t('helper.others')"
              v-model="financialInfo.source_of_income_text"
              :error="v$?.source_of_income_text.$error"
          />
        </div>
      </CustomCheckboxGroup>
      <p v-if="v$?.source_of_income.$error" class="error-message">{{ $t('kyc.at_least_one') }}</p>
      <div class="mb-4"/>
      <h5 class="kyc-sub-title">{{ $t('kyc.salary') }}</h5>
      <CustomCheckboxGroup v-model="selectedIncomeOptions"
                           :options="incomeOptions"
                           :multiple="false"
      />
      <p v-if="v$?.salary.$error" class="error-message">{{ $t('kyc.choose_one') }}</p>
      <div class="mb-4"/>
      <h5 class="kyc-sub-title">{{ $t('kyc.trading_amount') }}</h5>
      <CustomCheckboxGroup v-model="selectedTradeOptions"
                           :options="tradeOptions"
                           :multiple="false"
      />
      <p v-if="v$?.trading_amount.$error" class="error-message">{{ $t('kyc.choose_one') }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.kyc-sub-title {
  font-size: 14px;
  font-weight: 500;
  color: var(primary-color-new);
}
</style>